import { Registration } from '../../domain/models';


export class RegistrationViewModel {
    public id: string;
    public registrationId: string;
    public startTime: Date;
    public endTime: Date;
    public startX: number;
    public startY: number;
    public endX: number;
    public endY: number;

    constructor();
    constructor(json: any);
    constructor(json?: Registration) {
        if (json) {
            this.id = json.id;
            this.registrationId = json.registrationId;
            this.startTime = json.startTime;
            this.endTime = json.endTime;
            this.startX = json.startX;
            this.startY = json.startY;
            this.endX = json.endX;
            this.endY = json.endY;
        }
    }

    public hasCoordinates(): boolean {
        return (this.startX != null && this.startY != null) || (this.endX != null && this.endY != null);
    }

    public getCoordinatesDisplayString(): string {
        return this.endX != null && this.endY != null
            ? this.startY + ',' + this.startX + ' - ' + this.endY + ',' + this.endX
            : this.startY + ',' + this.startX;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/distribution/view-models/registration.view-model.ts